var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-container',[_c('center',{staticStyle:{"margin-top":"24px"}},[_c('p',[_vm._v("ご予約を承りました。")]),_c('br'),_c('a',{attrs:{"href":_vm.rootRoute}},[_c('p',[_vm._v("トップに戻る>")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }